import React from "react";
import styles from "./contato.module.css";
import imgContato from "../../images/_finais/ImagemContato_compress.webp";
import { SendEmail } from "../../utils/SendEmail";
import { ISendEmail, IResponseEmail } from "../../interfaces/sendEmail";

interface IContato {
  name?: string;
  phone?: string;
  email?: string;
  message?: string;
}

const ContatoPage = () => {
  const [contato, setContato] = React.useState<IContato>({});

  const onChangeName = (input: any) => {
    input.preventDefault();
    setContato({ ...contato, name: input.target.value });
  };

  const onChangePhone = (input: any) => {
    input.preventDefault();

    let phone = input.target.value;
    phone = phone.replace(/\D/g, "");

    if (phone.length <= 11) {
      const formattedPhone = phone.replace(
        /^(\d{2})(\d{5})(\d{0,4})$/,
        "($1) $2-$3"
      );

      console.log(formattedPhone);

      setContato({ ...contato, phone: formattedPhone });
    }
  };

  const onChangeEmail = (input: any) => {
    input.preventDefault();
    setContato({ ...contato, email: input.target.value });
  };

  const onChangeMessage = (input: any) => {
    input.preventDefault();
    setContato({ ...contato, message: input.target.value });
  };

  const validateMessageContent = (input: IContato) => {
    if (!input.name || (input.name && input.name.length < 3)) {
      return {
        isValid: false,
        details: "Nome deve conter ao menos três caracteres.",
      };
    }

    if (!input.phone || (input.phone && input.phone.length < 11)) {
      return { isValid: false, details: "Número de telefone inválido." };
    }

    if (!input.email) {
      return { isValid: false, details: "Email inválido." };
    }

    if (input.email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(input.email)) {
        return { isValid: false, details: "Email inválido." };
      }
    }

    if (!input.message || (input.message && input.message.length < 20)) {
      return {
        isValid: false,
        details: "Mensagem deve conter ao menos 20 caracteres.",
      };
    }

    if (!input.message || (input.message && input.message.length > 400)) {
      return {
        isValid: false,
        details: "Mensagem deve conter no máximo 400 caracteres.",
      };
    }

    return {
      isValid: true,
      details: "Validado.",
    };
  };

  const onClickSendMessage = async (input: IContato) => {
    const validateInput = validateMessageContent(input);

    if (!validateInput.isValid) {
      return alert(validateInput.details);
    }

    const emailObj: ISendEmail = {
      name: input.name!,
      phone: input.phone!,
      message: input.message!,
      emailFrom: input.email!,
    };

    const responseEmail: IResponseEmail | undefined = await SendEmail(emailObj);

    if (!responseEmail) {
      return alert("'Erro ao enviar email.");
    }

    if (!responseEmail.success) {
      return alert(responseEmail.message);
    }

    setContato({});

    return alert("Email enviado.");
  };

  return (
    <main className={styles.contato_main}>
      <section className={styles.contato_section}>
        <div className={styles.contato_div}>
          <div className={styles.form_div}>
            <div className={styles.title_div}>
              <h2 className={styles.contato_title}>ENTRE EM CONTATO</h2>
              <span className={styles.line}></span>
            </div>

            <div className={styles.input_row}>
              <div className={styles.input_div}>
                <label className={styles.label}>Nome*</label>
                <input
                  className={styles.input}
                  type="text"
                  value={contato?.name || ""}
                  onChange={(e: any) => onChangeName(e)}
                />
              </div>
              <div className={styles.input_div}>
                <label className={styles.label}>Telefone*</label>
                <input
                  className={styles.input}
                  type="text"
                  value={contato?.phone || ""}
                  onChange={(e: any) => onChangePhone(e)}
                />
              </div>
            </div>
            <div className={styles.input_row}>
              <div className={styles.input_single_div}>
                <label className={styles.label}>Email*</label>
                <input
                  className={styles.input}
                  type="text"
                  value={contato?.email || ""}
                  onChange={(e: any) => onChangeEmail(e)}
                />
              </div>
            </div>
            <div className={styles.input_row}>
              <div className={styles.input_div}>
                <label className={styles.label}>
                  Mensagem* (até 400 caracteres)
                </label>
                <textarea
                  className={styles.input_msg}
                  maxLength={400}
                  value={contato?.message || ""}
                  onChange={(e: any) => onChangeMessage(e)}
                />
              </div>
            </div>
            <button
              className={styles.btn_enviarMsg}
              onClick={() => onClickSendMessage(contato)}
            >
              ENVIAR MENSAGEM
            </button>
          </div>

          <div className={styles.form_divMobile}>
            <div className={styles.title_div}>
              <h2 className={styles.contato_title}>ENTRE EM CONTATO</h2>
              <span className={styles.line}></span>
            </div>

            <div className={styles.input_row}>
              <div className={styles.input_div}>
                <label className={styles.label}>Nome*</label>
                <input
                  className={styles.input}
                  type="text"
                  value={contato?.name || ""}
                  onChange={(e: any) => onChangeName(e)}
                />
              </div>
              <div className={styles.input_div}>
                <label className={styles.label}>Telefone*</label>
                <input
                  className={styles.input}
                  type="text"
                  value={contato?.phone || ""}
                  onChange={(e: any) => onChangePhone(e)}
                />
              </div>
              <div className={styles.input_div}>
                <label className={styles.label}>Email*</label>
                <input
                  className={styles.input}
                  type="text"
                  value={contato?.email || ""}
                  onChange={(e: any) => onChangeEmail(e)}
                />
              </div>
              <div className={styles.input_div}>
                <label className={styles.label}>
                  Mensagem* (até 400 caracteres)
                </label>
                <textarea
                  className={styles.input_msg}
                  maxLength={400}
                  value={contato?.message || ""}
                  onChange={(e: any) => onChangeMessage(e)}
                />
              </div>
            </div>
            <button
              className={styles.btn_enviarMsg}
              onClick={() => onClickSendMessage(contato)}
            >
              ENVIAR MENSAGEM
            </button>
          </div>

          <img
            className={styles.contato_img}
            src={imgContato}
            alt="Contato imagem."
            loading="lazy"
          />
        </div>
      </section>
    </main>
  );
};

export default ContatoPage;
